import type { StorageFullMessage } from './storage-full-dialog';

/** The owner can extend the plan; everyone else learns whom to ask. */
export function storageFullMessage(
  isOwner: boolean,
  memberOverflow: boolean
): StorageFullMessage {
  if (isOwner) {
    return memberOverflow
      ? {
          description:
            'com.streamlain.payment.sync-paused.owner.both.description',
          tips: [
            'com.streamlain.payment.sync-paused.owner.both.tips-1',
            'com.streamlain.payment.sync-paused.owner.both.tips-2',
          ],
          cancelText: 'com.streamlain.payment.billing-setting.cancel',
          confirmText: 'com.streamlain.payment.upgrade',
        }
      : {
          description:
            'com.streamlain.payment.sync-paused.owner.storage.description',
          tips: [
            'com.streamlain.payment.sync-paused.owner.storage.tips-1',
            'com.streamlain.payment.sync-paused.owner.storage.tips-2',
          ],
          cancelText: 'com.streamlain.payment.billing-setting.cancel',
          confirmText: 'com.streamlain.payment.upgrade',
        };
  }
  return {
    description: memberOverflow
      ? 'com.streamlain.payment.sync-paused.member.both.description'
      : 'com.streamlain.payment.sync-paused.member.storage.description',
    tips: [],
    confirmText: 'com.streamlain.payment.sync-paused.member.member.confirm',
  };
}
